/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsersMinus: {
  name: 'users-minus';
  data: string;
} = {
  name: 'users-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM4 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm11 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM3 20a5 5 0 0 1 10 0 1 1 0 1 0 2 0c0-1.49-.465-2.87-1.258-4.004a2.948 2.948 0 0 1 1.728.325c.816.433 1.38 1.202 1.56 1.922a1 1 0 1 0 1.94-.485c-.32-1.281-1.256-2.512-2.565-3.204-1.2-.636-2.695-.808-4.272-.204A7 7 0 0 0 1 20a1 1 0 1 0 2 0ZM19 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z" fill="currentColor"/></svg>`,
};
